import React from "react";
import Breadcrumbs from "../../../../../../components/Breadcrumbs";
import { Link } from "react-router-dom";
import { Table, Pagination, Tooltip } from "antd";
import AddJobModal from "../../../../../../components/Administration/Jobs/ManageJobs/AddJobModal";
import EditJobModal from "../../../../../../components/Administration/Jobs/ManageJobs/EditJobModal";
import DeleteModal from "../../../../../../components/modelpopup/deletePopup";
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";
import { useJob } from "../../context";
import { formatDateHandler2 } from "utils/common";
import { SkeltonLoader } from "components/skeltonLoader";
import {Button} from "components/Button";

const ManageJobs = () => {
  const {
    loading,
    jobList,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleJobDetailPage,
    handleDateChange,
    createJobHandler,
    jobModal, setJobModal,
    setSelectedJob, selectedJob

  } = useJob();

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: true,
    },
    {
      title: "Job Title",
      dataIndex: "title",
      render: (text,record) => <Link to={`/manage-resumes?job=${record.id}`}>{text}</Link>,
      sorter: true,
    },

    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   render: (text) => (
    //     <Tooltip title={text}>
    //       <span className="truncate-text">{text.length > 100 ? `${text.substring(0, 100)}...` : text}</span>
    //     </Tooltip>
    //   ),
    //   // sorter: (a, b) => a.department.length - b.department.length,
    // },
    {
      title: "Department",
      dataIndex: "department",
      render: (text,record)=> (
        <div className="dropdown action-label text-center">
            <span className={`badge badge-soft-primary`}>{record?.department?.name || record?.department}</span>  

        </div>
      )
      // sorter: (a, b) => a.department.length - b.department.length,
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      sorter: true,
      render: (text) => <>{formatDateHandler2(text)}</>,
    },

    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      sorter: true,
      render: (text) => <>{formatDateHandler2(text)}</>,
    },
    {
      title: "Job Type",
      dataIndex: "jobtype",
      render: (text) => (
        <div className="dropdown action-label text-center">
            <span className={`badge badge-soft-warning`}>Full time</span>  

        </div>
      ),
      sorter: (a, b) => a.jobtype.length - b.jobtype.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <div className="dropdown action-label text-center">
           <span className={`badge badge-soft-${ text=="open" ?  "success" : "danger"}`}>{text}</span>  
          {/* <Link
            className="btn btn-white btn-sm btn-rounded dropdown-toggle"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i
              className={
                text === "open"
                  ? "far fa-dot-circle text-info"
                  : text === "closed"
                  ? "far fa-dot-circle text-success"
                  : "far fa-dot-circle text-danger"
              }
            />{" "}
            {text}
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-info" /> Open
            </Link>
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-success" /> Closed
            </Link>
            <Link className="dropdown-item" to="#">
              <i className="far fa-dot-circle text-danger" /> Cancelled
            </Link>
          </div> */}
        </div>
      ),
      sorter: true,
    },
    // {
    //   title: "Vacancy",
    //   dataIndex: "application_count",
    //   render: (text) => (
    //     <span className={`badge badge-soft-danger`}>{text} Vacancy</span>  
    //     // <Link
    //     //   to="/app/administrator/job-applicants"
    //     //   className="btn btn-sm btn-primary"
    //     // >
    //     //   {text} Vacancy
    //     // </Link>
    //   ),
    //   sorter: (a, b) => a.application_count.length - b.application_count.length,
    // },
    {
      title: "Applicants",
      dataIndex: "applicant_count",
      render: (text,record) => (
         
        <Link
          to={`/manage-resumes?job=${record.id}`}
          // className="btn btn-sm btn-primary"
        >
          <span className={`badge badge-soft-primary`}>{text} Applicants</span> 
        </Link>
      ),
      sorter: (a, b) => a.applicant_count.length - b.applicant_count.length,
    },
    {
      title: "Action",
      render: (text , record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
            onClick={()=>{
              setJobModal(true)
              setSelectedJob(record)

            }}
              // to="#"
              className="dropdown-item"
              // data-bs-toggle="modal"
              // data-bs-target="#edit_job"
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              data-bs-toggle="modal"
              data-bs-target="#delete"
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {jobList.map((job, index) => (
           
           <div
              className="col-md-6 col-sm-1 col-12 col-lg-3 col-xl-4"
              key={job.id}
            >
              <div className="profile-widget">
               
                <div className="row" >
                  {/* <div className="col-4" >
                  <div className="profile-img">
                    <a   className="avatar">
                   
                      <Image  src={job?.image} type="user" alt="User Image"/>
                    </a>
                  </div>
                  
                  </div> */}
                 
                  <div  className="col-8" >
                  <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                  <a 
                  // to={`/profile/${employee.id}`}

                  >
                    {job.title} 
                  </a>
                </h4>
                <div className="m-t-10 small text-muted text-start">
                  <Tooltip title={job.description}>
                    <span className="truncate-text">
                      {job.description?.length > 80 ? `${job.description.substring(0, 80)}...` : job.description}
                    </span>
                  </Tooltip>
                </div>
                <div className="m-t-10 small text-muted text-start">Created at : {formatDateHandler2(job.created_at)}</div>

                <div className="m-t-10 small text-muted text-start ">
                <span className={`me-1 badge badge-soft-${ job.status=="open" ?  "success" : "danger"}`}>{job.status}</span> 
                <span className={`me-1 badge badge-soft-danger`}>{job.vacancy} Vacancy</span> 
                <span className={`me-1 badge badge-soft-primary`}>{job.applicant_count} Applicants</span> 
                    </div>
                  </div>
                  
                    </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Jobs"
            title="Dashboard"
            subtitle="Jobs"
            modal="#add_job"
            name="Add Job"
            view={view}
            setJobModal={setJobModal}
            setView={setView}
            isGrid={false}
            // hideGrid={true}
          />
          
          <style jsx>{`
            .truncate-text {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 100%;
              display: block;
            }
          `}</style>

          <div className="row">
            <div className="col-md-12">
            {view == "grid" ? (
                <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
            )
            :
              <div className="table-responsive">
              <Table
              
              // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  className="table-striped"
                  columns={columns}
                  dataSource={jobList}
                  rowKey={(record) => record.id}
                  loading={loading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  onChange={handleChange}
                />
                {/* <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={data}
                  rowKey={(record) => record.id}
                  pagination={false}
                /> */}
              </div>
}
            </div>
          </div>
          <AddJobModal setSelectedJob={setSelectedJob} selectedJob={selectedJob} loading={loading} createJobHandler={createJobHandler} jobModal={jobModal} setJobModal={setJobModal} />
          {/* <EditJobModal /> */}
          <DeleteModal Name="Delete Job" />
        </div>
      </div>
    </>
  );
};

export default ManageJobs;
